import React from 'react'
import {useLoaderData, useNavigate} from "react-router";
import {VlogFields} from "./_fields";
import * as API from '@/api'
import {Form} from "../../ui/elements/form";
import {Button} from "../../ui/elements/button";

export const VlogManager = props => {
  const { vlog } = useLoaderData()
  const navigate = useNavigate()

  const onSubmit = (evt) => {
    evt.preventDefault()
    const formData = new FormData(evt.target)

    return API.Vlogs.update(vlog.id, formData).then(() => navigate(`/vlogs/${vlog.id}`))
  }

  return <Form onSubmit={onSubmit} className="w-full">
      <VlogFields vlog={vlog} onSubmit={onSubmit} />
      <div>
        <Button type="submit" label="Save" />
      </div>
    </Form>
}
